// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#lt-yantr.va-loan-calc .advanced-calc-filter .error-msg{font-size:12px;color:#fe0000}#lt-yantr.va-loan-calc .advanced-calc-filter .filter-inputs>li label{display:block}#lt-yantr.va-loan-calc .low-score-msg{font-size:17px;line-height:25px;text-align:center;max-width:516px;margin:0 auto 40px;font-weight:700}#lt-yantr.va-loan-calc .county-title{text-align:center;margin-bottom:40px}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
